import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 11l-6 4v-4H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgCommentinline;
